import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  messageBaseUrl: '',
  access_token: '',
  s3_url: '',
  idp:'',
  newsFeedBaseUrl : '',
  public_profile: '',
  has_certificate_document: '',
  certificate_upload_path: '',
  user_uuid: '',
  id:'',
  success_doc: false,
  session: {},
  certificatecount: 0,
  coursecount: 0,
  externaldoccount: 0,
  programcount: 0,
  discussionFormEnable: 0,
  dms_setting: {},
  dms_api_url: '',
  mail_email: '',
  global_tax_percentage: 0,
  tmp_profile_image: '',
  tmp_banner_image: '',
  active_sp_enrollment: '',
  address_mandatory: 0,
  phno_mandatory: 0,
  org_mandatory: 0,
};

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfigData: (state, action) => {
        // console.log(state,"state")
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      for (let x in action.payload) {
        if (x in state) {
          state[x] = action.payload[x];
        }
      }
    },
    resetConfigData: () => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setConfigData, resetConfigData } = configSlice.actions;

export default configSlice.reducer;